import(/* webpackMode: "eager", webpackExports: ["DotsEffect"] */ "/vercel/path0/components/ui/dots-effect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PixelEffect"] */ "/vercel/path0/components/ui/pixel-effect-dynamic.tsx");
